import sharingCopy from '../i18n/ns/sharing-connectors.ts';

export function sharingCopyFor(locale?: string) {
  const language = (locale ?? 'en').toLowerCase().split('-')[0];
  return sharingCopy[language as keyof typeof sharingCopy] ?? sharingCopy.en;
}
